export const parseChartValue = (value: any): number => {
  if (typeof value === 'number') {
    return value;
  }
  
  if (typeof value === 'string') {
    let cleaned = value.replace(/[$£€¥,]/g, '');
    
    const hasK = cleaned.toUpperCase().includes('K');
    const hasM = cleaned.toUpperCase().includes('M');
    
    cleaned = cleaned.replace(/[^\d.-]/g, '');
    let parsed = parseFloat(cleaned);
    
    if (isNaN(parsed)) return 0;
    
    if (hasK) parsed *= 1000;
    if (hasM) parsed *= 1000000;
    
    return parsed;
  }
  
  return 0;
};

export const formatChartValue = (originalValue: unknown): string => {
  if (originalValue === null || originalValue === undefined) {
    return '';
  }

  if (typeof originalValue === 'string') {
    return originalValue;
  }

  return String(originalValue);
};


export const detectDataStructure = (data: any): 'simple' | 'nested-timeseries' | 'nested-categories' => {
  if (!data || typeof data !== 'object') return 'simple';
  
  const firstValue = Object.values(data)[0];
  
  if (typeof firstValue !== 'object') {
    return 'simple';
  }
  
  const firstKey = Object.keys(data)[0];
  if (/^\d{4}$/.test(firstKey) || firstKey.match(/^\d{4}-\d{2}$/)) {
    return 'nested-timeseries';
  }
  
  return 'nested-categories';
};